export default {
    namespaced:true,
    state:{
        user:{}
    },
    getters:{
        getUser(state){
            return state.user
        }
    },
    mutations:{
        setUser(state,payload){
            state.user=payload
        },
        setUserBalance(state,payload){
            state.user.discountBalance=payload
        }
    },
    actions:{
        setUserAction({commit},payload){
            commit('setUser',payload)
        },
        setUserBalanceAction({commit},payload){
            commit('setUserBalance',payload)
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js